import { render, staticRenderFns } from "./AssessmentItem2.vue?vue&type=template&id=6e94dfd0&scoped=true&"
import script from "./AssessmentItem2.vue?vue&type=script&lang=js&"
export * from "./AssessmentItem2.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentItem2.vue?vue&type=style&index=0&id=6e94dfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94dfd0",
  null
  
)

export default component.exports